import companyInterceptor from 'api/interceptors/companyInterceptor';

import { setEndpoint } from '../configure';

import type { CompanyType } from '../api.types';

export const [fetchCompany] = setEndpoint<any, any, any, CompanyType>({
  path: '/company.json',
  id: 'fetchCompany',
  method: 'GET',
  namespace: 'company',
  globals: {
    interceptor: {
      after: [companyInterceptor],
    },
  },
});

export const [updateCompany] = setEndpoint<any, any, any, CompanyType>({
  path: '/company.json',
  id: 'updateCompany',
  method: 'PUT',
  namespace: 'company',
  globals: {
    contentType: 'application/json',
    interceptor: {
      after: [companyInterceptor],
    },
  },
});

export type UpdateCompanyRequest = {
  name?: string;
  url?: string;
  description?: string;
  slug?: string;
  DUNSNumber?: string;
  facebookUsername?: string;
  twitterUsername?: string;
  linkedinUsername?: string;
  googleUsername?: string;
  passwordAuthEnabled?: boolean;
  passkeyAuthEnabled?: boolean;
  requireRecoveryApproval?: boolean;
  emailNotifyOnAuthEvents?: boolean;
  featureFlag?: [string | number | (string | number)[], any]; // 2 item array of [path, value]
  addEmailDomains?: string[]; // array of email domains to add
  removeEmailDomains?: string[]; // array of email domains to remove
};
